import { memo, useState } from "react";
import type { Merchant } from "features/merchants/types";
import { getSetupsKYCSwitch, updateSetupsKYCSwitch } from "features/setups/api";
import Resource from "ui/layouts/Resource";
import { WebRoutes } from "consts/enpoints/web";
import MasterConnection from "ui/organizms/Merchants/MasterConnection";
import EditMerchantKycDialog from "../EditMerchantKycDialog";
import MerchantKycSettingsTable from "../MerchantKycSettingsTable";

const KYCMerchantList = () => {
    const [editingMerchant, setEditingMerchant] = useState<Merchant | null>(null);
    const [reloadToken, setReloadToken] = useState(0);

    const openEdit = (merchant: Merchant) => setEditingMerchant(merchant);
    const closeEdit = () => setEditingMerchant(null);

    const handleSaved = () => {
        setReloadToken(token => token + 1);
        setEditingMerchant(null);
    };

    const masterSwitch = (
        <MasterConnection
            getSetupsMasterConnectionSwitch={getSetupsKYCSwitch}
            updateSetupsMasterConnectionSwitch={updateSetupsKYCSwitch}
            content={[
                {
                    dialogContent: [
                        'Are you sure you want to enable the KYC connection for all merchants?',
                        "This action will activate Shufti Pro's services for the merchants with enabled KYC settings."
                    ],
                    actionContent: 'Enable KYC'
                },
                {
                    dialogContent: [
                        'Are you sure you want to disable the KYC connection for all merchants?',
                        "This action will shut down Shufti Pro's services."
                    ],
                    actionContent: 'Disable KYC'
                }
            ]}
        />
    );

    return (
        <Resource
            title='Merchants | KYC Settings'
            breadcrumbsProps={{
                heading: 'Merchant KYC Settings',
                links: [
                    { name: 'KYC Settings', href: WebRoutes.KYCSettings.Index },
                    { name: 'Merchant' }
                ]
            }}
        >
            <MerchantKycSettingsTable
                action={masterSwitch}
                onEdit={openEdit}
                reloadToken={reloadToken}
            />
            <EditMerchantKycDialog
                merchant={editingMerchant}
                open={editingMerchant !== null}
                onClose={closeEdit}
                onSaved={handleSaved}
            />
        </Resource>
    );
};

export default memo(KYCMerchantList);
